import { createAction } from "redux-actions";

export default createAction("THEME_LOADED");
